import MicroModal from "micromodal";

const defaultOption = {
  disableScroll: true,
  awaitCloseAnimation: true,
};
const notDisableScrollOptions = {
  disableScroll: false,
  awaitCloseAnimation: true,
};
const forCalendarOptions = (addOption) => {
  if (!addOption) return;
  return {
    disableScroll: true,
    awaitCloseAnimation: true,
    onClose: addOption,
  };
};

export const modalShow = (target, addOption = null) => {
  switch (target) {
    case "modal-calendar-information":
      MicroModal.show(target, notDisableScrollOptions);
      break;
    case "modal-calendar-setting":
    case "modal-calendar-settingBatch":
      MicroModal.show(target, forCalendarOptions(addOption));
      break;
    default:
      MicroModal.show(target, defaultOption);
  }
};

export const modalClose = (target) => {
  MicroModal.close(target);
};
